import React, {useState} from "react";
import {subscribeToAd} from "../../../util/ad_api_utils";
import {setCookie} from "../../../util/cookie_utils";
import {SlideOutAdModal} from "./SlideOutAdModal";
import {PopupAdModal} from "./PopupAdModal";
import {trackLead} from "../../../util/tracking_utils";

export const AdModalForm = (props) => {
  const [error, setError] = useState('')
  const [subscribing, setSubscribing] = useState(false)

  const {
    showToast, title, description, button_text, imageUrl, isVertical,
    adId, coupon_code, onClose, onSubscribed, show, type, ad_type,
    openProjectModalWithInfo
  } = props

  const onSubmit = (e, email, companyWebsite) => {
    e.preventDefault()
    if (subscribing) return
    if (!email) {
      setError("Email should be present")
      return;
    } else {
      setError("")
    }

    setSubscribing(true)
    subscribeToAd(email, adId, companyWebsite).then(() => {
      // Lets the discount this ad promises auto-apply on the homepage order
      // flow later, instead of the person needing to dig the emailed code
      // back out and type it in (see create_project_home_page_modal.jsx).
      if (coupon_code) {
        setCookie("pending_discount_code", coupon_code, 30)
      }
      trackLead(ad_type === 'slide_out' ? 'discount_slide_out' : 'discount_popup')
      onSubscribed()
      showToast("You have subscribed successfully")
      if (coupon_code) {
        openProjectModalWithInfo(null)
      }
    }).catch(response => {
      const errors = response?.responseJSON;
      setError(Array.isArray(errors) ? errors.join(' ') : 'Your signup could not be completed. Please try again.');
      setSubscribing(false)
    })
  }

  const Component = ad_type === 'slide_out' ? SlideOutAdModal : PopupAdModal

  return <Component error={error} title={title} description={description} subscribing={subscribing}
                    button_text={button_text} imageUrl={imageUrl} isVertical={isVertical} type={type}
                    onClose={onClose} show={show} onSubmit={onSubmit}/>
}
